/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetFactoriesByGroupID,
    GetFDCInboundTransactionsReportData,
    GetVCCFactoriesByGroupID,
    GetFDCInboundTransactionsReportaTotalValues,
    GetFDCList
    
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFDCInboundTransactionsReportData(model) {
    const response = await CommonPost('/api/FDCInboundTransactionsReport/GetFDCInboundTransactionsReportData', null, model);
    return response.data;
}

async function GetFDCInboundTransactionsReportaTotalValues(model) {
    const response = await CommonPost('/api/FDCInboundTransactionsReport/GetFDCInboundTransactionsReportaTotalValues', null, model);
    return response.data;
}

async function GetFDCList(groupID) {
    const response = await CommonPost('/api/FDCInboundTransactionsReport/GetFDCList', null, { groupID: parseInt(groupID), factoryTypeID: 1 });
    return response.data;
}